export enum JobStatusIds {
  NEW = 0,
  ASSIGNED = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
  FAILED = 4,
  PARTIALLY_COMPLETED = 5,
}
export enum JobStatusSegment {
  'new' = 0,
  'assigned' = 1,
  'inprogress' = 2,
  'completed' = 3,
  'failed' = 4,
  'partiallycompleted' = 5,
}
export enum DelayStatusId {
  DELAYED = 1,
  ON_TIME = 2,
}
export enum TaskStaticStatusIds {
  PENDING = 1,
  IN_PROGRESS = 2,
  COMPLETED= 3,
  COMPLETED_WITH_POLICY= 31,
  FAILED = 4,
  COMPLETED_PARTIALLY= 5,
  SKIPPED_BYSYS = 6,
  ARRIVED_AT_TASK_LOCATION = 7,
  JOB_EXPIRED = 8,
}

export enum TIME_TAGS {
  DELAYED = 2,
  ON_TIME = 1,
}

export enum Temperature_tags {

  DRY = 11,
  AMBIENT = 12,  
  CHILLED = 21,
  FROZEN = 22,
  

}

export enum PlanStatus {
  Draft = 1,
  New = 2,
  Approved = 3,
  Rejected = 4,
  InProgress = 5,
  Completed = 6,
  Pending = 7
}

